import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CollectiveDataProvider } from '../_providers/collective-data-provider';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../_providers/collective-data-provider";
export class PublicRedirectionGuard {
    constructor(router, collectiveDataProvider) {
        this.router = router;
        this.collectiveDataProvider = collectiveDataProvider;
        this.collectiveConfig = null;
    }
    canActivate(next, state) {
        this.collectiveDataProvider.getData().subscribe((c) => {
            this.collectiveConfig = c;
            if (!environment.protected && this.collectiveConfig.active == 0) {
                return true;
            }
            if (!environment.protected && this.collectiveConfig.active == 1) {
                this.router.navigateByUrl('service-index');
                return false;
            }
        });
        return true;
    }
}
PublicRedirectionGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PublicRedirectionGuard_Factory() { return new PublicRedirectionGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.CollectiveDataProvider)); }, token: PublicRedirectionGuard, providedIn: "root" });
